var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.noText)?[_vm._v(" "+_vm._s(_vm.timeAgo(_vm.date))+" ")]:[_vm._v(" "+_vm._s(_vm.text)+_vm._s(_vm.timeAgo(_vm.date))+" ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }